import { Prompt } from "../../components/Prompt.js";
import { Button, FormControlLabel, Radio, RadioGroup, Stack, TextField } from "@mui/material";
import React, { useEffect } from "react";
import { makeStyles } from "tss-react/mui";
import { Controller, useFormContext } from "react-hook-form";
import { locationName } from "../../store/formContent.js";
import { InputField } from "../../components/InputField.js";

const useStyles = makeStyles()((theme) => ({
  root: {
    height: "100vh",
    width: "100vw",
    //justifyContent: "center",
    alignItems: "center",
    //justifyItems: "center",
    padding: theme.spacing(10),
    direction: "column"
  }

}));

const Info4 = (props) => {

  const { classes } = useStyles();
  const { slideId, activeField, setActive, loginStatus, setValidationList, children } = props;

  const { control, formState: { errors } } = useFormContext();
  useEffect(() => {
    if (activeField === slideId) {
      setValidationList(["locationType","locationName"]);
    }
  }, [activeField]);
  // const [selectedCard, setSelectedCard] = useState(1);
  /*
    const handleCardClick = (e, value) => {
      console.log(value);
      console.log(e.target.id);
    };*/

  return (
    <Stack className={classes.root} spacing={5}>
      <Prompt prompt={"Specify a location for this audience"} index={4} />
      <Controller
        id={"locationType"}
        name={"locationType"}
        control={control}
        defaultValue="national"
        render={({ field: { onChange, onBlur, value, ref }, fieldState: { error } }) => (
          <RadioGroup row aria-label="locationType" value={value} onChange={onChange} >
            <FormControlLabel value="national" control={<Radio />} label="National" />
            <FormControlLabel value="regional" control={<Radio />} label="Regional" />
            <FormControlLabel value="local" control={<Radio />} label="Local" />
            <InputField {...locationName} control={control} setActive={setActive} slideId={slideId} />
          </RadioGroup>
        )} />

      <Prompt prompt={"Anything else we should know?"} />
{/*
      <InputField sx={{ width: "80vw", maxWidth:"1000px", border: 1 }} {...comments} control={control} slideId={slideId}/>
*/}
     <Controller
        id={"comments"}
        name={"comments"}
        render={({ field: { onChange, onBlur, value, ref }, fieldState: { error } }) => (
          <TextField variant="filled" sx={{ width: "80%", border: 1 }}
                     placeholder="Questions/Comments"
                     multiline={true}
                     rows={10}
                     value={value}
                     inputRef={ref}
                     type={"text"}
                     onChange={onChange}
          />
        )} />
      {loginStatus &&
      <Button
        className={classes.Submit}
        type="submit"
        variant="contained"
        color="primary"
      >
        Submit
      </Button>
      }
    </Stack>
  );
};

export { Info4 };